import axios from 'axios'

export default axios.create({
    baseURL: 'https://api.gestioncaplp.org.ar/api'
})

    //baseURL: 'http://localhost:8000/api'
    //baseURL: 'http://144.91.80.128:8093/api' --api test
    //baseURL: 'http://144.91.80.128:8090/api' --api prod
    //baseURL: 'https://api.gestioncaplp.org.ar/api' --api prod
